import { isLeft } from "fp-ts/lib/Either";
import { inject } from "mobx-react";
import { createRef } from "react";
import * as React from "react";
import classnames from "classnames";
import { HtmlBlockValueResolver } from "@ihr-radioedit/inferno-core";
import type { BlockFragment } from "@ihr-radioedit/inferno-webapi";
import { bindHashAnchorLinks, scrollToAnchor } from "../lib/utilities";
import { activateEmbeds } from "../lib/embed";
import { Container } from "../ui";
import styles from "./Html.module.scss";
import type { Store } from "@inferno/renderer-shared-core";

@inject("store")
export class Html extends React.Component<{ block: BlockFragment; store?: Store }, {}> {
  contentRef: React.RefObject<HTMLDivElement> = createRef();

  componentDidUpdate() {
    this.props.store?.storeBlock(this.props.block);

    if (this.contentRef.current) {
      activateEmbeds(this.contentRef.current);
    }
  }

  componentDidMount() {
    bindHashAnchorLinks(this.contentRef);
    if (typeof window !== "undefined") {
      window.addEventListener(
        "load",
        () => {
          const id = window.location.href.split("#")[1];
          if (id) {
            scrollToAnchor(document.getElementById(id));
          }
        },
        { once: true },
      );
    }

    if (this.contentRef.current) {
      activateEmbeds(this.contentRef.current);
    }
  }

  render() {
    const { block, store } = this.props;
    if (!store) {
      return null;
    }
    const value = HtmlBlockValueResolver.decode(block.value);
    if (isLeft(value) || !value.right.content) {
      return null;
    }

    const htmlContainerClass = classnames(styles.componentHtml, {
      [styles.htmlContentStyle]: block.tags?.includes("display-hints/html-content-style"),
    });

    return (
      <Container data-test-type={block.type} className={htmlContainerClass}>
        <div dangerouslySetInnerHTML={{ __html: value.right.content }} ref={this.contentRef} />
      </Container>
    );
  }
}
